export default function clx(...classes) {
  return classes.filter(Boolean).join(' ');
}
